import { registerThemeProperties } from "@ui5/webcomponents-base/dist/asset-registries/Themes.js";

import defaultThemeBase from "@ui5/webcomponents-theme-base/dist/generated/themes/sap_fiori_3/parameters-bundle.css.js";
import defaultTheme from "./sap_fiori_3/parameters-bundle.css.js";

registerThemeProperties("@ui5/webcomponents-theme-base", "sap_fiori_3", defaultThemeBase);
registerThemeProperties("@ui5/webcomponents", "sap_fiori_3", defaultTheme);
export default ":host{min-width:1px;display:none;position:fixed}";